var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("604 Labs")]),_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.login}},[_vm._v(" Signin with Google ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }